import { Link } from 'react-router-dom';
import { Button } from '@marine/ui/button';
import { Card, CardContent } from '@marine/ui/card';
import { toAbsoluteUrl } from '@/lib/helpers';
import { Home, ArrowLeft } from 'lucide-react';

export function NotFoundPage() {
  const lightBg = '/media/images/auth/2600x1600/admin-login-light.png';
  const darkBg = '/media/images/auth/2600x1600/admin-login-dark.png';

  return (
    <>
      <style>
        {`
          .branded-bg-404 {
            background-image: url('${toAbsoluteUrl(lightBg)}');
          }
          .dark .branded-bg-404 {
            background-image: url('${toAbsoluteUrl(darkBg)}');
          }
        `}
      </style>
      <div className="grid lg:grid-cols-2 grow min-h-screen">
        <div className="flex justify-center items-center p-8 lg:p-10 order-2 lg:order-1">
          <Card className="w-full max-w-[500px]">
            <CardContent className="p-8">
              <div className="text-center space-y-6">
                {/* Large 404 */}
                <div className="space-y-2">
                  <h1 className="text-8xl font-bold text-primary/20">404</h1>
                  <h2 className="text-2xl font-semibold tracking-tight">Page Not Found</h2>
                  <p className="text-sm text-muted-foreground">
                    The page you are looking for doesn't exist or has been moved.
                  </p>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
                  <Button asChild>
                    <Link to="/dashboard" className="flex items-center gap-2">
                      <Home className="h-4 w-4" />
                      Go to Dashboard
                    </Link>
                  </Button>
                  <Button asChild variant="outline" onClick={() => window.history.back()}>
                    <button className="flex items-center gap-2">
                      <ArrowLeft className="h-4 w-4" />
                      Go Back
                    </button>
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="lg:rounded-xl lg:border lg:border-border lg:m-5 order-1 lg:order-2 bg-top xxl:bg-center xl:bg-cover bg-no-repeat branded-bg-404">
          <div className="flex flex-col p-8 lg:p-16 gap-4">
            <Link to="/">
              <div className="text-2xl font-bold text-mono">
                Marine DMS
              </div>
            </Link>

            <div className="flex flex-col gap-3">
              <h3 className="text-2xl font-semibold text-mono">
                Page Not Found
              </h3>
              <div className="text-base font-medium text-secondary-foreground">
                <>
                  Navigate back to the platform with our<br />secure&nbsp;
                  <span className="text-mono font-semibold">
                    administrative dashboard
                  </span>
                  <br />and continue your work.
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
